/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { CrmIntegration } from './CrmIntegration.js';
import {
    CrmIntegrationFromJSON,
    CrmIntegrationFromJSONTyped,
    CrmIntegrationToJSON,
} from './CrmIntegration.js';

/**
 * 
 * @export
 * @interface CrmIntegrationResponse
 */
export interface CrmIntegrationResponse {
    /**
     * 
     * @type {CrmIntegration}
     * @memberof CrmIntegrationResponse
     */
    data?: CrmIntegration;
    /**
     * 
     * @type {number}
     * @memberof CrmIntegrationResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof CrmIntegrationResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CrmIntegrationResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof CrmIntegrationResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the CrmIntegrationResponse interface.
 */
export function instanceOfCrmIntegrationResponse(value: object): boolean {
    return true;
}

export function CrmIntegrationResponseFromJSON(json: any): CrmIntegrationResponse {
    return CrmIntegrationResponseFromJSONTyped(json, false);
}

export function CrmIntegrationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmIntegrationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CrmIntegrationFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function CrmIntegrationResponseToJSON(value?: CrmIntegrationResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': CrmIntegrationToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

